import { safeTrim } from 'src/lib/stringUtil';

const VAT_CONFIG = {
    enabledCountries: new Set(['HUN', 'PRT']),
    enabledTiers: new Set(['13', '14']),
}

export default function isVatIDRequired(userAgentTier: string, countryCode: string): boolean {
    return VAT_CONFIG.enabledTiers.has(userAgentTier) && 
           VAT_CONFIG.enabledCountries.has(safeTrim(countryCode).toUpperCase());
}